import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useWeb3 } from '../context/Web3Context';
import UnauthorizedPage from '../pages/UnauthorizedPage';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { isConnected } = useWeb3();

  if (!isAuthenticated && !isConnected) {
    return <UnauthorizedPage />;
  }

  return children;
};

export default ProtectedRoute;
